import React from "react";
import { Route } from "react-router-dom";
import ReturnGoodsRoute from "./return-goods";
import TakingGoodsRoute from "./taking-goods";
import WarehouseInRoute from "./warehouse-in";
import WarehouseOutRoute from "./warehouse-out";

export default function WarehouseRoutes( props ) {
    return (
    <Route path="/warehouse">
        {ReturnGoodsRoute(props)}
        {TakingGoodsRoute(props)}
        {WarehouseInRoute(props)}
        {WarehouseOutRoute(props)}
    </Route>
    )
}